import React, { useMemo, useState } from "react";
import styled, { keyframes } from "styled-components";

import SpectrumsAINEW from "../assets/spectrumsAINEW.png";
import GUMROADaiChatbotTemplates from "../assets/GUMROADaiChatbotTemplates.jpg";
import Archédex from "../assets/archédex.png";
import Mindpulse150 from "../assets/mindpulse150.jpg";
import ArchetypeAPI from "../assets/archetypeAPI.jpg";
import VoicesOfTheMagiScreenshot from "../assets/voiceofthemagi.jpg";
import HuggyfaceArchetypeFinder from "../assets/HuggyfaceArchetypeFinder.jpg";
import FormRAGIMG from "../assets/FormRAGIMG.jpg";
import smallshopMarketplace from "../assets/smallshopMarketplaceNew.jpg";
import InvoiceGen from "../assets/InvoiceGen.jpg";
import OrderFulfillmentTracker from "../assets/OrderFulfillmentTracker.jpg";
import InventoryAlertSystem from "../assets/InventoryAlertSystem.jpg";
import landscapeImg from "../assets/landscapeImgNew.jpg";
import cleaningHomecare from "../assets/cleaningHomecare.jpg";
import electricianHandyman from "../assets/electricianHandyman.jpg";
import mechanicRepairman from "../assets/mechanicRepairman.jpg";
import authorWriter from "../assets/authorWriter.jpg";
import showcaseRealEstate from "../assets/showcaseRealEstate.jpg";
import LawIMG from "../assets/law.png";
import TheArchetypeBrandTransformer from "../assets/TheArchetypeBrandTransformer.png";
import NewStorySpinnerLogo from "../assets/newStorySpinnerLogo.png";
import RebelAdvisorIMG from "../assets/RebelAdvisorIMG.png";
import BusinessRebrandingTool from "../assets/BusinessRebrandingTool.png";
import StrategicBusinessPlanner from "../assets/StrategicBusinessPlanner.png";
import showcaseWorkflowAutomation from "../assets/showcaseWorkflowAutomation.jpg";
import showcaseCustomerService from "../assets/showcaseCustomerService.jpg";
import showcaseFinancialServices from "../assets/showcaseFinancialServices.jpg";
import showcaseHealthcareAgents from "../assets/showcaseHealthcareAgents.jpg";
import LocalLearn from "../assets/locallearn2.jpg";
import DataVanguardLite from "../assets/DataVanguardLite.jpg";
import { HomeButton } from "../../pages/MemoryPalAILearnMore";

const demoVideo = "/videos/homeschoolGuideAI-founder-video.mp4";
const CALENDLY = "//cal.com/james-studiovoice2fly.com/ai-strategy-session";
const INQUIRE_EMAIL = "james@studiovoice2fly.com";
const CLIENT_PREVIEW_COUNT = 6;

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(18px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Page = styled.div`
  position: relative;
  min-height: 100vh;
  padding-bottom: 7rem;
  font-family: "VT323", monospace;
  color: #e8ffe9;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.55) 0%,
    rgba(0, 0, 0, 0.72) 35%,
    rgba(0, 0, 0, 0.78) calc(100% - 11rem),
    rgba(0, 0, 0, 0.35) calc(100% - 4rem),
    transparent 100%
  );
`;

const Hero = styled.section`
  position: relative;
  min-height: ${(p) => (p.$playing ? "auto" : "min(84vh, 760px)")};
  display: flex;
  align-items: ${(p) => (p.$playing ? "stretch" : "flex-end")};
  overflow: hidden;
  isolation: isolate;
  background: #000;
`;

const HeroArt = styled.div`
  position: ${(p) => (p.$playing ? "relative" : "absolute")};
  inset: ${(p) => (p.$playing ? "auto" : "0")};
  z-index: 0;
  width: 100%;
  background: #000;
  min-height: ${(p) => (p.$playing ? "0" : "100%")};
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center 20%;
    display: block;
  }

  video {
    width: 100%;
    max-height: min(78vh, 780px);
    height: auto;
    object-fit: contain;
    display: block;
    background: #000;
  }

  &::after {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    opacity: ${(p) => (p.$playing ? 0 : 1)};
    transition: opacity 0.25s ease;
    background:
      linear-gradient(90deg, rgba(0, 0, 0, 0.92) 0%, rgba(0, 0, 0, 0.55) 48%, rgba(0, 0, 0, 0.35) 100%),
      linear-gradient(0deg, rgba(0, 0, 0, 0.92) 0%, rgba(0, 0, 0, 0.25) 55%, rgba(0, 0, 0, 0.45) 100%);
  }
`;

const VideoBar = styled.div`
  position: absolute;
  left: 50%;
  bottom: 1.1rem;
  z-index: 3;
  display: flex;
  gap: 0.5rem;
  transform: translateX(-50%);
`;

const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  width: min(1180px, calc(100% - 2.5rem));
  margin: 0 auto;
  padding: 7rem 0 2.5rem;
  animation: ${fadeUp} 0.6s ease both;

  @media (max-width: 700px) {
    padding: 6.25rem 0 1.75rem;
  }
`;

const HeroKicker = styled.p`
  margin: 0 0 0.7rem;
  font-size: 1rem;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: #45fe47;
`;

const HeroTitle = styled.h1`
  margin: 0 0 0.55rem;
  max-width: 14ch;
  font-size: clamp(2.5rem, 7vw, 4.4rem);
  font-weight: 400;
  line-height: 0.95;
  text-transform: uppercase;
  color: #fff;
`;

const HeroLead = styled.p`
  margin: 0 0 1.2rem;
  max-width: 36rem;
  font-size: clamp(1.1rem, 2.2vw, 1.35rem);
  line-height: 1.4;
  color: rgba(69, 254, 71, 0.92);
`;

const HeroTags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
`;

const Tag = styled.span`
  padding: 0.28rem 0.7rem;
  border: 1px solid rgba(69, 254, 71, 0.7);
  color: #45fe47;
  font-size: 0.95rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
`;

const HeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
`;

const ActionBtn = styled.button`
  font-family: "VT323", monospace;
  font-size: 1.12rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.7rem 1.15rem;
  border: 1px solid #45fe47;
  cursor: pointer;
  background: ${(p) => (p.$primary ? "#45fe47" : "rgba(0, 0, 0, 0.45)")};
  color: ${(p) => (p.$primary ? "#000" : "#45fe47")};
  backdrop-filter: blur(6px);

  &:hover {
    background: #fff;
    color: #000;
    border-color: #fff;
  }
`;

const Body = styled.div`
  width: min(1180px, calc(100% - 2.5rem));
  margin: 0 auto;
  padding: 1.75rem 0 1.5rem;
`;

const JumpNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 2.25rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(69, 254, 71, 0.25);
  animation: ${fadeUp} 0.55s ease 0.08s both;
`;

const JumpLink = styled.a`
  padding: 0.4rem 0.8rem;
  border: 1px solid rgba(69, 254, 71, 0.4);
  color: #45fe47;
  text-decoration: none;
  text-transform: uppercase;
  font-size: 1rem;
  letter-spacing: 0.04em;
  background: rgba(0, 0, 0, 0.35);

  &:hover {
    border-color: #45fe47;
    background: rgba(69, 254, 71, 0.12);
  }
`;

const Section = styled.section`
  margin-bottom: 3rem;
  scroll-margin-top: 90px;
  animation: ${fadeUp} 0.55s ease both;
  animation-delay: ${(p) => p.$delay || "0.12s"};
`;

const SectionHead = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 0.85rem 1rem;
  align-items: start;
  margin-bottom: 1.25rem;
  max-width: 760px;
`;

const SectionIndex = styled.span`
  font-size: 1rem;
  letter-spacing: 0.12em;
  color: #45fe47;
  padding-top: 0.35rem;
`;

const SectionCopy = styled.div``;

const SectionTitle = styled.h2`
  margin: 0 0 0.3rem;
  font-size: clamp(1.5rem, 3vw, 1.95rem);
  font-weight: 400;
  color: #fff;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

const SectionNote = styled.p`
  margin: 0;
  font-size: 1.08rem;
  line-height: 1.35;
  color: #9aa0a6;
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.1rem;

  @media (max-width: 980px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const TerminalCard = styled.article`
  display: flex;
  flex-direction: column;
  background: rgba(0, 8, 0, 0.82);
  border: 1px solid rgba(69, 254, 71, 0.28);
  overflow: hidden;
  transition: border-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    border-color: #45fe47;
    box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35), 0 0 18px rgba(69, 254, 71, 0.12);
    transform: translateY(-4px);
  }

  &:hover img {
    transform: scale(1.04);
  }
`;

const MonitorScreen = styled.div`
  position: relative;
  aspect-ratio: 16 / 10;
  background: #000;
  overflow: hidden;
  border-bottom: 1px solid rgba(69, 254, 71, 0.2);

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.35s ease;
  }
`;

const StatusBadge = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
  padding: 0.2rem 0.55rem;
  background: ${(p) => p.$color || "#45fe47"};
  color: #000;
  font-size: 0.85rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  box-shadow: 2px 2px 0 #000;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0.95rem 1rem 1.05rem;
`;

const AppTitle = styled.h3`
  margin: 0 0 0.4rem;
  color: #fff;
  font-size: 1.28rem;
  font-weight: 400;
  line-height: 1.15;
  text-transform: uppercase;
`;

const Description = styled.p`
  margin: 0 0 1rem;
  color: rgba(69, 254, 71, 0.86);
  font-size: 1.02rem;
  line-height: 1.35;
  flex-grow: 1;
`;

const InterfacePanel = styled.div`
  margin-top: auto;
  padding-top: 0.8rem;
  border-top: 1px solid rgba(69, 254, 71, 0.22);
`;

const CommandBtn = styled.button`
  width: 100%;
  padding: 0.55rem 0.75rem;
  font-family: "VT323", monospace;
  font-size: 1.05rem;
  text-transform: uppercase;
  cursor: pointer;
  border: 1px solid #45fe47;
  background: ${(p) => (p.$highlight ? "#45fe47" : "transparent")};
  color: ${(p) => (p.$highlight ? "#000" : "#45fe47")};

  &:hover {
    background: #fff;
    color: #000;
    border-color: #fff;
  }
`;

const ShowMoreBtn = styled.button`
  display: block;
  margin: 1.1rem auto 0;
  padding: 0.55rem 1.1rem;
  font-family: "VT323", monospace;
  font-size: 1.05rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #45fe47;
  background: transparent;
  border: 1px solid rgba(69, 254, 71, 0.55);
  cursor: pointer;

  &:hover {
    border-color: #45fe47;
    background: rgba(69, 254, 71, 0.1);
  }
`;

const CtaBand = styled.section`
  margin-top: 1.5rem;
  padding: 1.8rem 1.25rem;
  border: 1px solid rgba(69, 254, 71, 0.45);
  background: rgba(0, 8, 0, 0.75);
  text-align: center;
`;

const CtaTitle = styled.h3`
  margin: 0 0 0.45rem;
  font-size: 1.7rem;
  font-weight: 400;
  color: #fff;
  text-transform: uppercase;
`;

const CtaText = styled.p`
  margin: 0 auto 1.1rem;
  max-width: 34rem;
  font-size: 1.12rem;
  line-height: 1.4;
  color: rgba(69, 254, 71, 0.88);
`;

const CtaActions = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.65rem;
`;

const CtaLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 150px;
  padding: 0.65rem 1.1rem;
  font-family: "VT323", monospace;
  font-size: 1.1rem;
  text-decoration: none;
  text-transform: uppercase;
  border: 1px solid #45fe47;
  background: ${(p) => (p.$primary ? "#45fe47" : "transparent")};
  color: ${(p) => (p.$primary ? "#000" : "#45fe47")};

  &:hover {
    background: #fff;
    color: #000;
    border-color: #fff;
  }
`;

const flagship = {
  id: "hsg",
  image: SpectrumsAINEW,
  video: demoVideo,
  name: "Homeschool Guide AI",
  desc: "My active startup — a second brain for homeschooling families supporting neurodivergent learners. Turns learner context into clearer daily decisions.",
  link: "https://homeschoolguide.ai",
};

const sections = [
  {
    id: "available",
    index: "01",
    title: "Available now",
    note: "Live products, demos, and tools you can open today.",
    items: [
      {
        id: "templates",
        image: GUMROADaiChatbotTemplates,
        name: "AI Chatbot Templates",
        desc: "5 customizable HTML chatbot landing templates, each with an optional AI-driven chat experience.",
        link: "https://jrq3rqstudio.gumroad.com/l/ailanding",
        type: "PRODUCT",
        badgeColor: "#ffe501",
        isProduct: true,
      },
      {
        id: "smb",
        image: smallshopMarketplace,
        name: "Small Biz Bots",
        desc: "Convert visitors to buyers with smart, automated sales conversations.",
        link: "https://jrq3rqstudio.gumroad.com/l/ailanding",
        type: "PRODUCT",
        badgeColor: "#ffe501",
        isProduct: true,
      },
      {
        id: "formrag",
        image: FormRAGIMG,
        name: "form-rag-js",
        desc: "One AI form for any business—powered by Grok. Structured templates replace prompts for quotes.",
        link: "https://www.npmjs.com/package/form-rag-js",
        type: "NPM",
        badgeColor: "#ff2d55",
      },
      {
        id: "magi",
        image: VoicesOfTheMagiScreenshot,
        name: "Voice of the Magi",
        desc: "Chat with the three Biblical Magi. A quiet Epiphany journey built with Grok.",
        link: "https://voices-of-the-magi.web.app/",
        type: "DEMO",
        badgeColor: "#ff2d55",
      },
      {
        id: "legal",
        image: LawIMG,
        name: "AI Legal Aid",
        desc: "Summarizes documents and manages legal tasks for paralegals.",
        link: "https://github.com/jrq3rq/AI-chrome-ext",
        type: "TOOL",
        badgeColor: "#ff2d55",
      },
    ],
  },
  {
    id: "archetype",
    index: "02",
    title: "Archetype systems",
    note: "Psychological frameworks, assessments, and narrative AI — the studio’s core IP.",
    items: [
      {
        id: "archedex",
        image: Archédex,
        name: "Archédex",
        desc: "Your personal AI guide inside The Archetype Academy. Chat interface powered by your archetype profile.",
        link: "https://archetype-academy-nexus.web.app/archedex-demo",
        type: "CONCEPT",
        badgeColor: "#9D4EDD",
      },
      {
        id: "mp150",
        image: Mindpulse150,
        name: "Mindpulse150",
        desc: "Big Five personality test. Score unlocks your complementary archetype and entry to the Academy.",
        link: "https://archetype-academy-nexus.web.app/assessment",
        type: "CONCEPT",
        badgeColor: "#9D4EDD",
      },
      {
        id: "api",
        image: ArchetypeAPI,
        name: "Archetype API",
        desc: "JSON API delivering 12 Jungian archetypes with full profiles. Built for writers and developers.",
        link: "https://us-central1-archetype-builder-api.cloudfunctions.net/api/archetypes/",
        type: "API",
        badgeColor: "#00C2FF",
      },
      {
        id: "finder",
        image: HuggyfaceArchetypeFinder,
        name: "AI Archetype Finder",
        desc: "Archetype concept demo hosted on HuggingFace Spaces.",
        link: "https://huggingface.co/spaces/jrq3rq/AI-Archetype-Finder",
        type: "LABS",
        badgeColor: "#43fe47",
      },
    ],
  },
  {
    id: "client-work",
    index: "03",
    title: "What I can build for you",
    note: "Client-ready examples — inquire to adapt one for your business or workflow.",
    collapsible: true,
    items: [
      {
        id: "locallearn",
        image: LocalLearn,
        name: "Local Learn",
        desc: "Offline AI learning companion for personalized, self-directed, and off-grid education.",
        link: "inquire",
        type: "EDU_TOOL",
        badgeColor: "#22c55e",
      },
      {
        id: "datavanguard-lite",
        image: DataVanguardLite,
        name: "Data Vanguard LT",
        desc: "Local privacy coach that helps audit data brokers and generate opt-out requests.",
        link: "inquire",
        type: "PRIVACY_TOOL",
        badgeColor: "#3b82f6",
      },
      {
        id: "workflow-automation",
        image: showcaseWorkflowAutomation,
        name: "Workflow Automation Agents",
        desc: "Multi-agent systems for sales, marketing, and IT operations.",
        link: "inquire",
        type: "AGENT",
        badgeColor: "#0ea5e9",
      },
      {
        id: "customer-service",
        image: showcaseCustomerService,
        name: "Customer Service Agents",
        desc: "Specialized agent teams for 24/7 support and ticket resolution.",
        link: "inquire",
        type: "AGENT",
        badgeColor: "#0ea5e9",
      },
      {
        id: "financial-services",
        image: showcaseFinancialServices,
        name: "Finance Agent Suite",
        desc: "Agentic pipelines for fraud, loans, and compliance workflows.",
        link: "inquire",
        type: "AGENT",
        badgeColor: "#0ea5e9",
      },
      {
        id: "healthcare-agents",
        image: showcaseHealthcareAgents,
        name: "Healthcare Clinical Agents",
        desc: "Multi-agent clinical workflows for diagnostics and intake.",
        link: "inquire",
        type: "AGENT",
        badgeColor: "#0ea5e9",
      },
      {
        id: "inv",
        image: InvoiceGen,
        name: "Invoice Gen",
        desc: "Speed up invoicing and reduce human error with AI-assisted formatting.",
        link: "inquire",
        type: "SMB_TOOL",
        badgeColor: "#ff2d55",
      },
      {
        id: "fulfillment",
        image: OrderFulfillmentTracker,
        name: "Order Tracker",
        desc: "Visualize, track, and manage order pipelines in real time.",
        link: "inquire",
        type: "SMB_TOOL",
        badgeColor: "#ff2d55",
      },
      {
        id: "inventory",
        image: InventoryAlertSystem,
        name: "Inventory Alerts",
        desc: "Stay ahead of stockouts and overstock with proactive AI alerts.",
        link: "inquire",
        type: "SMB_TOOL",
        badgeColor: "#ff2d55",
      },
      {
        id: "lawn",
        image: landscapeImg,
        name: "Lawn Care PWA",
        desc: "Showcase services, schedule jobs, and grow local reach.",
        link: "inquire",
        type: "PWA",
        badgeColor: "#43fe47",
      },
      {
        id: "cleaning",
        image: cleaningHomecare,
        name: "Cleaning PWA",
        desc: "Let clients book, review, and recommend with ease.",
        link: "inquire",
        type: "PWA",
        badgeColor: "#43fe47",
      },
      {
        id: "handyman",
        image: electricianHandyman,
        name: "Handyman PWA",
        desc: "Automate job intake, estimate quotes, and upsell services.",
        link: "inquire",
        type: "PWA",
        badgeColor: "#43fe47",
      },
      {
        id: "mechanic",
        image: mechanicRepairman,
        name: "Mechanic PWA",
        desc: "Streamline repair scheduling and offer service updates.",
        link: "inquire",
        type: "PWA",
        badgeColor: "#43fe47",
      },
      {
        id: "author",
        image: authorWriter,
        name: "Author PWA",
        desc: "Grow your digital footprint and convert readers into fans.",
        link: "inquire",
        type: "PWA",
        badgeColor: "#43fe47",
      },
      {
        id: "realestate",
        image: showcaseRealEstate,
        name: "Real Estate PWA",
        desc: "Automate lead gen, manage listings, and close faster.",
        link: "inquire",
        type: "PWA",
        badgeColor: "#43fe47",
      },
    ],
  },
  {
    id: "labs",
    index: "04",
    title: "Labs & GPTs",
    note: "Lightweight experiments and custom GPT tools.",
    items: [
      {
        id: "brand",
        image: TheArchetypeBrandTransformer,
        name: "Branding GPT",
        desc: "Crafts brand identities using design, archetypes, and strategy.",
        link: "https://chat.openai.com/g/g-SXTcCxFtV-archetype-brand-transformer",
        type: "GPT",
        badgeColor: "#32CD32",
      },
      {
        id: "story",
        image: NewStorySpinnerLogo,
        name: "Story Spinner",
        desc: "Remix classic stories into fresh narratives with AI remixing.",
        link: "https://chat.openai.com/g/g-7T3hhDJO7-storyspinner",
        type: "GPT",
        badgeColor: "#32CD32",
      },
      {
        id: "rebel",
        image: RebelAdvisorIMG,
        name: "Rebel Advisor",
        desc: "Provides honest, critical feedback to stress-test your ideas.",
        link: "https://chat.openai.com/g/g-KjtcrDj33-rebel-advisor",
        type: "GPT",
        badgeColor: "#32CD32",
      },
      {
        id: "rebrand",
        image: BusinessRebrandingTool,
        name: "Rebranding Tool",
        desc: "Discover new naming angles—from logical to wild reinventions.",
        link: "https://chat.openai.com/g/g-np3Dj7gOE-business-rebranding-tool",
        type: "GPT",
        badgeColor: "#32CD32",
      },
      {
        id: "partner",
        image: StrategicBusinessPlanner,
        name: "Partner GPT",
        desc: "Run SWOTs, explore pivots, and clarify strategy on demand.",
        link: "https://chat.openai.com/g/g-3aqW0lmMT-strategic-business-partner",
        type: "GPT",
        badgeColor: "#32CD32",
      },
    ],
  },
];

const actionLabel = (item) => {
  if (item.link === "inquire") return "[ Inquire ]";
  if (item.isProduct) return "[ Buy now ]";
  return "[ Launch ]";
};

const PortfolioCard = ({ item, onAction }) => (
  <TerminalCard>
    <MonitorScreen>
      <StatusBadge $color={item.badgeColor}>{item.type}</StatusBadge>
      <img src={item.image} alt="" />
    </MonitorScreen>
    <CardBody>
      <AppTitle>{item.name}</AppTitle>
      <Description>{item.desc}</Description>
      <InterfacePanel>
        <CommandBtn $highlight type="button" onClick={() => onAction(item)}>
          {actionLabel(item)}
        </CommandBtn>
      </InterfacePanel>
    </CardBody>
  </TerminalCard>
);

const PortfolioGrid = () => {
  const [playingVideo, setPlayingVideo] = useState(false);
  const [showAllClientWork, setShowAllClientWork] = useState(false);

  const delays = useMemo(() => ["0.1s", "0.16s", "0.22s", "0.28s"], []);

  const handleAction = (item) => {
    if (item.link === "inquire") {
      window.location.href = `mailto:${INQUIRE_EMAIL}?subject=${encodeURIComponent(
        `Inquiry: ${item.name}`
      )}`;
      return;
    }
    window.open(item.link, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <HomeButton to="/">Home</HomeButton>
      <Page>
        <Hero $playing={playingVideo}>
          <HeroArt $playing={playingVideo}>
            {playingVideo ? (
              <video
                src={flagship.video}
                autoPlay
                controls
                playsInline
                onEnded={() => setPlayingVideo(false)}
              />
            ) : (
              <img src={flagship.image} alt={flagship.name} />
            )}
            {playingVideo && (
              <VideoBar>
                <ActionBtn type="button" onClick={() => setPlayingVideo(false)}>
                  Stop video
                </ActionBtn>
              </VideoBar>
            )}
          </HeroArt>
          {!playingVideo && (
            <HeroContent>
              <HeroKicker>Active startup · Studio Voice2fly</HeroKicker>
              <HeroTitle>{flagship.name}</HeroTitle>
              <HeroLead>{flagship.desc}</HeroLead>
              <HeroTags>
                <Tag>Live</Tag>
                <Tag>Neurodivergent learning</Tag>
                <Tag>Flagship</Tag>
              </HeroTags>
              <HeroActions>
                <ActionBtn
                  $primary
                  type="button"
                  onClick={() => handleAction(flagship)}
                >
                  Visit site
                </ActionBtn>
                <ActionBtn
                  type="button"
                  onClick={() => setPlayingVideo(true)}
                >
                  Play founder video
                </ActionBtn>
              </HeroActions>
            </HeroContent>
          )}
        </Hero>

        <Body>
          <JumpNav aria-label="Portfolio sections">
            {sections.map((section) => (
              <JumpLink key={section.id} href={`#${section.id}`}>
                {section.index} {section.title}
              </JumpLink>
            ))}
          </JumpNav>

          {sections.map((section, index) => {
            const items =
              section.collapsible && !showAllClientWork
                ? section.items.slice(0, CLIENT_PREVIEW_COUNT)
                : section.items;
            const hiddenCount = section.collapsible
              ? section.items.length - CLIENT_PREVIEW_COUNT
              : 0;

            return (
              <Section
                key={section.id}
                id={section.id}
                $delay={delays[index] || "0.15s"}
              >
                <SectionHead>
                  <SectionIndex>{section.index}</SectionIndex>
                  <SectionCopy>
                    <SectionTitle>{section.title}</SectionTitle>
                    <SectionNote>{section.note}</SectionNote>
                  </SectionCopy>
                </SectionHead>

                <CardGrid>
                  {items.map((item) => (
                    <PortfolioCard
                      key={item.id}
                      item={item}
                      onAction={handleAction}
                    />
                  ))}
                </CardGrid>

                {section.collapsible && hiddenCount > 0 && (
                  <ShowMoreBtn
                    type="button"
                    onClick={() => setShowAllClientWork((v) => !v)}
                  >
                    {showAllClientWork
                      ? "Show fewer examples"
                      : `Show ${hiddenCount} more examples`}
                  </ShowMoreBtn>
                )}
              </Section>
            );
          })}

          <CtaBand>
            <CtaTitle>Need something built?</CtaTitle>
            <CtaText>
              I design and ship practical AI tools for learning, small business,
              and archetype-powered products.
            </CtaText>
            <CtaActions>
              <CtaLink
                $primary
                href={CALENDLY}
                target="_blank"
                rel="noopener noreferrer"
              >
                Book a call
              </CtaLink>
              <CtaLink href={`mailto:${INQUIRE_EMAIL}`}>Email me</CtaLink>
            </CtaActions>
          </CtaBand>
        </Body>
      </Page>
    </>
  );
};

export default PortfolioGrid;
